import { Link } from "react-router-dom";
function Dashboard() {
  return (
    <>
      <div>
        <div className="sidebar text-gray-700 shadow" data-visible="false">
          <div>
            <div className="flex items-center justify-center relative py-4 gap-4 border-b border-border_cl">
              <span className=" px-3 py-3 bg-[#F1F0FB] text-gray-500 transition duration-150 ease-in-out flex items-center justify-center h-12 w-12 font-medium rounded-full hover:bg-blue-700 hover:shadow-lg hover:text-white focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg active:text-white ">
                RW
              </span>
              <div className="flex items-start justify-start flex-col">
                <span className="h4 text-xl font-semibold">Rebecca Wilson</span>
                <span className="profile">0xc3d899E.....F6206</span>
              </div>
            </div>

            <div className="flex items-center justify-center relative py-5 border-b border-border_cl block w-full">
              <Link
                to="newinvoice.html"
                className="text-sm text-secondary flex items-center justify-center block w-full"
              >
                <span className="mr-4">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 3.33325V12.6666"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.83203 8H13.1654"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                Create new Invoice
              </Link>
            </div>
          </div>
          <nav className="mt-6">
            <div className="px-1">
              <Link
                className=" menu-item active w-full font-thin uppercase text-gray_cl  flex items-center p-3 px-4  my-3  transition-colors duration-200 ease-in justify-start "
                to="#"
              >
                <span className="text-left  px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    className="m-auto"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6.6013 11.2248C7.7763 11.2248 8.71797 12.1757 8.71797 13.359V16.1998C8.71797 17.3748 7.7763 18.3332 6.6013 18.3332H3.78464C2.61797 18.3332 1.66797 17.3748 1.66797 16.1998V13.359C1.66797 12.1757 2.61797 11.2248 3.78464 11.2248H6.6013ZM16.218 11.2248C17.3847 11.2248 18.3347 12.1757 18.3347 13.359V16.1998C18.3347 17.3748 17.3847 18.3332 16.218 18.3332H13.4014C12.2264 18.3332 11.2847 17.3748 11.2847 16.1998V13.359C11.2847 12.1757 12.2264 11.2248 13.4014 11.2248H16.218ZM6.6013 1.66675C7.7763 1.66675 8.71797 2.62508 8.71797 3.80091V6.64175C8.71797 7.82508 7.7763 8.77508 6.6013 8.77508H3.78464C2.61797 8.77508 1.66797 7.82508 1.66797 6.64175V3.80091C1.66797 2.62508 2.61797 1.66675 3.78464 1.66675H6.6013ZM16.218 1.66675C17.3847 1.66675 18.3347 2.62508 18.3347 3.80091V6.64175C18.3347 7.82508 17.3847 8.77508 16.218 8.77508H13.4014C12.2264 8.77508 11.2847 7.82508 11.2847 6.64175V3.80091C11.2847 2.62508 12.2264 1.66675 13.4014 1.66675H16.218Z" />
                  </svg>
                </span>
                <span className="mx-4 textName-sm font-normal">Overview</span>
              </Link>
              <Link
                className=" menu-item w-full font-thin uppercase text-gray_cl flex items-center p-3 px-4 my-3 transition-colors duration-200 ease-in justify-start hover:text-secondary"
                to="invoices.html"
              >
                <span className="text-left px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.63411 9.68341C7.60911 9.68341 7.59245 9.68341 7.56745 9.68341C7.52578 9.67508 7.46745 9.67508 7.41745 9.68341C5.00078 9.60841 3.17578 7.70841 3.17578 5.36675C3.17578 2.98341 5.11745 1.04175 7.50078 1.04175C9.88411 1.04175 11.8258 2.98341 11.8258 5.36675C11.8174 7.70841 9.98411 9.60841 7.65911 9.68341C7.65078 9.68341 7.64245 9.68341 7.63411 9.68341ZM7.50078 2.29175C5.80911 2.29175 4.42578 3.67508 4.42578 5.36675C4.42578 7.03341 5.72578 8.37508 7.38411 8.43341C7.43411 8.42508 7.54245 8.42508 7.65078 8.43341C9.28412 8.35841 10.5674 7.01675 10.5758 5.36675C10.5758 3.67508 9.19245 2.29175 7.50078 2.29175Z" />
                    <path d="M13.784 9.79159C13.759 9.79159 13.734 9.79159 13.709 9.78325C13.3673 9.81659 13.0173 9.57492 12.984 9.23325C12.9506 8.89159 13.159 8.58325 13.5006 8.54159C13.6006 8.53325 13.709 8.53325 13.8006 8.53325C15.0173 8.46659 15.9673 7.46659 15.9673 6.24159C15.9673 4.97492 14.9423 3.94992 13.6756 3.94992C13.334 3.95825 13.0506 3.67492 13.0506 3.33325C13.0506 2.99159 13.334 2.70825 13.6756 2.70825C15.6256 2.70825 17.2173 4.29992 17.2173 6.24992C17.2173 8.16659 15.7173 9.71659 13.809 9.79159C13.8006 9.79159 13.7923 9.79159 13.784 9.79159Z" />
                    <path d="M7.64036 18.7916C6.00703 18.7916 4.36536 18.3749 3.1237 17.5416C1.96536 16.7749 1.33203 15.7249 1.33203 14.5833C1.33203 13.4416 1.96536 12.3833 3.1237 11.6083C5.6237 9.94992 9.6737 9.94992 12.157 11.6083C13.307 12.3749 13.9487 13.4249 13.9487 14.5666C13.9487 15.7083 13.3154 16.7666 12.157 17.5416C10.907 18.3749 9.2737 18.7916 7.64036 18.7916ZM3.81536 12.6583C3.01536 13.1916 2.58203 13.8749 2.58203 14.5916C2.58203 15.2999 3.0237 15.9833 3.81536 16.5083C5.89036 17.8999 9.39036 17.8999 11.4654 16.5083C12.2654 15.9749 12.6987 15.2916 12.6987 14.5749C12.6987 13.8666 12.257 13.1833 11.4654 12.6583C9.39036 11.2749 5.89036 11.2749 3.81536 12.6583Z" />
                    <path d="M15.2844 17.2917C14.9928 17.2917 14.7344 17.0917 14.6761 16.7917C14.6094 16.45 14.8261 16.125 15.1594 16.05C15.6844 15.9417 16.1678 15.7333 16.5428 15.4417C17.0178 15.0833 17.2761 14.6333 17.2761 14.1583C17.2761 13.6833 17.0178 13.2333 16.5511 12.8833C16.1844 12.6 15.7261 12.4 15.1844 12.275C14.8511 12.2 14.6344 11.8667 14.7094 11.525C14.7844 11.1917 15.1178 10.975 15.4594 11.05C16.1761 11.2083 16.8011 11.4917 17.3094 11.8833C18.0844 12.4667 18.5261 13.2917 18.5261 14.1583C18.5261 15.025 18.0761 15.85 17.3011 16.4417C16.7844 16.8417 16.1344 17.1333 15.4178 17.275C15.3678 17.2917 15.3261 17.2917 15.2844 17.2917Z" />
                  </svg>
                </span>
                <span className="mx-4 text-sm font-normal">Invoices</span>
              </Link>
              <Link
                className=" menu-item w-full font-thin uppercase text-gray_cl  flex items-center p-3 px-4 my-3 transition-colors duration-200 justify-start hover:text-secondary"
                to="withdrawal.html"
              >
                <span className="text-left px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.332 5.00008V7.01675C18.332 8.33341 17.4987 9.16675 16.182 9.16675H13.332V3.34175C13.332 2.41675 14.0904 1.66675 15.0154 1.66675C15.9237 1.67508 16.757 2.04175 17.357 2.64175C17.957 3.25008 18.332 4.08341 18.332 5.00008Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.5 10.8416H10"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.5 7.5083H10"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1.66797 9.16675V17.5001C1.66797 18.1917 2.4513 18.5834 3.0013 18.1668L4.4263 17.1001C4.75964 16.8501 5.2263 16.8834 5.5263 17.1834L6.90964 18.5751C7.23464 18.9001 7.76797 18.9001 8.09297 18.5751L9.49297 17.1751C9.78464 16.8834 10.2513 16.8501 10.5763 17.1001L12.0013 18.1668C12.5513 18.5751 13.3346 18.1834 13.3346 17.5001V3.33341C13.3346 2.41675 14.0846 1.66675 15.0013 1.66675H5.83464H5.0013C2.5013 1.66675 1.66797 3.15841 1.66797 5.00008V5.83341"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.99609 10.8333H5.00358"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.99803 7.49992H5.00551"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="mx-4 text-sm font-normal">Withdrawals</span>
              </Link>
              <Link
                className=" menu-item w-full font-thin uppercase text-gray_cl flex items-center p-3 px-4 my-3 transition-colors duration-200 justify-start hover:text-secondary"
                to="#"
              >
                <span className="text-left px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.832 9.29175H5.83203"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1.66797 9.2917V5.4417C1.66797 3.7417 3.04297 2.3667 4.74297 2.3667H9.4263C11.1263 2.3667 12.5013 3.42503 12.5013 5.12503"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.568 10.1667C14.1513 10.5667 13.9513 11.1833 14.118 11.8166C14.3263 12.5916 15.093 13.0833 15.893 13.0833H16.668V14.2917C16.668 16.1333 15.1763 17.625 13.3346 17.625H5.0013C3.15964 17.625 1.66797 16.1333 1.66797 14.2917V8.45833C1.66797 6.61667 3.15964 5.125 5.0013 5.125H13.3346C15.168 5.125 16.668 6.625 16.668 8.45833V9.66663H15.768C15.3013 9.66663 14.8763 9.84999 14.568 10.1667Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.3329 10.5168V12.2334C18.3329 12.7001 17.9495 13.0834 17.4745 13.0834H15.8662C14.9662 13.0834 14.1412 12.4251 14.0662 11.5251C14.0162 11.0001 14.2162 10.5084 14.5662 10.1668C14.8745 9.85011 15.2995 9.66675 15.7662 9.66675H17.4745C17.9495 9.66675 18.3329 10.0501 18.3329 10.5168Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="mx-4 text-sm font-normal">Customers</span>
              </Link>
              <Link
                className=" menu-item w-full font-thin uppercase text-gray_cl flex items-center p-3 px-4 my-3 transition-colors duration-200 justify-start hover:text-secondary"
                to="referrals.html"
              >
                <span className="text-left px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.9984 5.967C14.9484 5.95866 14.8901 5.95866 14.8401 5.967C13.6901 5.92533 12.7734 4.98366 12.7734 3.81699C12.7734 2.62533 13.7318 1.66699 14.9234 1.66699C16.1151 1.66699 17.0734 2.63366 17.0734 3.81699C17.0651 4.98366 16.1484 5.92533 14.9984 5.967Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.1383 12.0338C15.28 12.2255 16.5383 12.0255 17.4216 11.4338C18.5966 10.6505 18.5966 9.36713 17.4216 8.58379C16.53 7.99213 15.2549 7.79212 14.1133 7.99212"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.97344 5.967C5.02344 5.95866 5.08177 5.95866 5.13177 5.967C6.28177 5.92533 7.19844 4.98366 7.19844 3.81699C7.19844 2.62533 6.24011 1.66699 5.04844 1.66699C3.85677 1.66699 2.89844 2.63366 2.89844 3.81699C2.90677 4.98366 3.82344 5.92533 4.97344 5.967Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.83255 12.0338C4.69088 12.2255 3.43255 12.0255 2.54922 11.4338C1.37422 10.6505 1.37422 9.36713 2.54922 8.58379C3.44089 7.99213 4.71588 7.79212 5.85755 7.99212"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.0023 12.1916C9.95234 12.1833 9.89401 12.1833 9.84401 12.1916C8.69401 12.1499 7.77734 11.2083 7.77734 10.0416C7.77734 8.84994 8.73568 7.8916 9.92734 7.8916C11.119 7.8916 12.0773 8.85827 12.0773 10.0416C12.069 11.2083 11.1523 12.1583 10.0023 12.1916Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.57656 14.8168C6.40156 15.6001 6.40156 16.8835 7.57656 17.6668C8.9099 18.5585 11.0932 18.5585 12.4266 17.6668C13.6016 16.8835 13.6016 15.6001 12.4266 14.8168C11.1016 13.9335 8.9099 13.9335 7.57656 14.8168Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="mx-4 text-sm font-normal">Referrals</span>
              </Link>
              <Link
                className=" menu-item w-full font-thin uppercase text-gray_cl flex items-center p-3 px-4 my-3 transition-colors duration-200 justify-start hover:text-secondary"
                to="#"
              >
                <span className="text-left px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.1654 12.4999C16.0544 12.7513 16.0213 13.0301 16.0704 13.3004C16.1194 13.5707 16.2482 13.8202 16.4404 14.0166L16.4904 14.0666C16.6453 14.2214 16.7683 14.4052 16.8521 14.6075C16.936 14.8098 16.9792 15.0267 16.9792 15.2458C16.9792 15.4648 16.936 15.6817 16.8521 15.884C16.7683 16.0863 16.6453 16.2701 16.4904 16.4249C16.3356 16.5799 16.1518 16.7028 15.9494 16.7867C15.7471 16.8706 15.5302 16.9137 15.3112 16.9137C15.0922 16.9137 14.8753 16.8706 14.673 16.7867C14.4706 16.7028 14.2868 16.5799 14.132 16.4249L14.082 16.3749C13.8856 16.1828 13.6362 16.0539 13.3659 16.0049C13.0955 15.9559 12.8167 15.989 12.5654 16.0999C12.3189 16.2056 12.1087 16.381 11.9606 16.6045C11.8126 16.8281 11.7331 17.0901 11.732 17.3583V17.4999C11.732 17.9419 11.5564 18.3659 11.2439 18.6784C10.9313 18.991 10.5074 19.1666 10.0654 19.1666C9.62334 19.1666 9.19941 18.991 8.88685 18.6784C8.57429 18.3659 8.3987 17.9419 8.3987 17.4999V17.4249C8.39225 17.1491 8.30296 16.8816 8.14246 16.6572C7.98195 16.4328 7.75764 16.2618 7.4987 16.1666C7.24735 16.0557 6.96854 16.0226 6.69821 16.0716C6.42788 16.1206 6.17843 16.2495 5.98203 16.4416L5.93203 16.4916C5.77724 16.6465 5.59343 16.7695 5.3911 16.8533C5.18877 16.9372 4.97189 16.9804 4.75286 16.9804C4.53384 16.9804 4.31696 16.9372 4.11463 16.8533C3.9123 16.7695 3.72849 16.6465 3.5737 16.4916C3.41874 16.3368 3.29581 16.153 3.21193 15.9507C3.12806 15.7483 3.08489 15.5314 3.08489 15.3124C3.08489 15.0934 3.12806 14.8765 3.21193 14.6742C3.29581 14.4719 3.41874 14.288 3.5737 14.1332L3.6237 14.0833C3.81581 13.8869 3.94469 13.6374 3.9937 13.3671C4.04272 13.0967 4.00963 12.8179 3.8987 12.5666C3.79306 12.3201 3.61766 12.1099 3.39409 11.9618C3.17051 11.8138 2.90852 11.7343 2.64036 11.7333H2.4987C2.05667 11.7333 1.63275 11.5577 1.32019 11.2451C1.00763 10.9325 0.832031 10.5086 0.832031 10.0666C0.832031 9.62456 1.00763 9.20063 1.32019 8.88807C1.63275 8.57551 2.05667 8.39992 2.4987 8.39992H2.5737C2.84953 8.39347 3.11703 8.30418 3.34145 8.14368C3.56586 7.98317 3.73679 7.75886 3.83203 7.49992C3.94296 7.24857 3.97605 6.96976 3.92703 6.69943C3.87802 6.4291 3.74914 6.17965 3.55703 5.98325L3.50703 5.93325C3.35207 5.77846 3.22914 5.59465 3.14526 5.39232C3.06139 5.18999 3.01822 4.97311 3.01822 4.75408C3.01822 4.53506 3.06139 4.31818 3.14526 4.11585C3.22914 3.91352 3.35207 3.72971 3.50703 3.57492C3.66182 3.41996 3.84563 3.29703 4.04796 3.21315C4.25029 3.12928 4.46717 3.08611 4.6862 3.08611C4.90522 3.08611 5.1221 3.12928 5.32443 3.21315C5.52676 3.29703 5.71058 3.41996 5.86536 3.57492L5.91536 3.62492C6.11176 3.81703 6.36121 3.94591 6.63154 3.99492C6.90187 4.04394 7.18068 4.01085 7.43203 3.89992H7.4987C7.74517 3.79428 7.95538 3.61888 8.10344 3.39531C8.2515 3.17173 8.33096 2.90974 8.33203 2.64159V2.49992C8.33203 2.05789 8.50763 1.63397 8.82019 1.32141C9.13275 1.00885 9.55667 0.833252 9.9987 0.833252C10.4407 0.833252 10.8646 1.00885 11.1772 1.32141C11.4898 1.63397 11.6654 2.05789 11.6654 2.49992V2.57492C11.6664 2.84307 11.7459 3.10506 11.894 3.32864C12.042 3.55221 12.2522 3.72762 12.4987 3.83325C12.75 3.94418 13.0289 3.97727 13.2992 3.92826C13.5695 3.87924 13.819 3.75037 14.0154 3.55825L14.0654 3.50825C14.2202 3.35329 14.404 3.23036 14.6063 3.14649C14.8086 3.06261 15.0255 3.01944 15.2445 3.01944C15.4636 3.01944 15.6804 3.06261 15.8828 3.14649C16.0851 3.23036 16.2689 3.35329 16.4237 3.50825C16.5787 3.66304 16.7016 3.84685 16.7855 4.04918C16.8693 4.25151 16.9125 4.46839 16.9125 4.68742C16.9125 4.90644 16.8693 5.12332 16.7855 5.32565C16.7016 5.52798 16.5787 5.7118 16.4237 5.86658L16.3737 5.91658C16.1816 6.11298 16.0527 6.36243 16.0037 6.63276C15.9547 6.90309 15.9878 7.1819 16.0987 7.43325V7.49992C16.2043 7.74639 16.3797 7.9566 16.6033 8.10466C16.8269 8.25272 17.0889 8.33218 17.357 8.33325H17.4987C17.9407 8.33325 18.3646 8.50885 18.6772 8.82141C18.9898 9.13397 19.1654 9.55789 19.1654 9.99992C19.1654 10.4419 18.9898 10.8659 18.6772 11.1784C18.3646 11.491 17.9407 11.6666 17.4987 11.6666H17.4237C17.1555 11.6677 16.8936 11.7471 16.67 11.8952C16.4464 12.0432 16.271 12.2534 16.1654 12.4999V12.4999Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="mx-4 text-sm font-normal">Settings</span>
              </Link>
            </div>
          </nav>
        </div>
        <div className="main">
          {/* <!--Header--> */}
          <div className="header z-50 sticky top-0 bg-white py-2 w-full px-4">
            <div className="container mx-auto flex items-center justify-between gap-8 md:px-4 ">
              <div>
                <button
                  type="button"
                  className="text-gray-500  hover:text-gray-600 focus:outline-none focus:text-gray-600 my-4 bg-border_cl border-gray-300 text-lg px-1 rounded-md mobile-menu-btn"
                  aria-label="toggle menu"
                >
                  <div className="bar-one"></div>
                  <div className="bar-two"></div>
                  <div className="bar-three"></div>
                </button>
              </div>
              <div className="flex items-center justify-end gap-1 md:gap-8 px-1 md:px-4">
                <div className="dropdown relative  grow  " data-large-dropdown>
                  <button
                    className="flex items-center justify-center gap-0 md:gap-4 border-r px-2 md:px-5 border-[#E4E7EC] focus:outline-none active:outline-none"
                    data-large-dropdown-btn
                  >
                    <div className="flex items-start justify-start flex-col pointer-events-none">
                      <span className="user font-medium ">Rebecca Wilson</span>
                      <span className="profile font-light text-gray_cl">
                        user
                      </span>
                    </div>
                    <span className="pointer-events-none">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="caret-down"
                        className="w-4 ml-2"
                        role="img"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.00099 11.7C7.53432 11.7 7.06766 11.5201 6.71432 11.1667L2.36766 6.82005C2.17432 6.62672 2.17432 6.30672 2.36766 6.11338C2.56099 5.92005 2.88099 5.92005 3.07432 6.11338L7.42099 10.4601C7.74099 10.7801 8.26099 10.7801 8.58099 10.4601L12.9277 6.11338C13.121 5.92005 13.441 5.92005 13.6343 6.11338C13.8277 6.30672 13.8277 6.62672 13.6343 6.82005L9.28766 11.1667C8.93432 11.5201 8.46766 11.7 8.00099 11.7Z"
                          fill="#4A4957"
                        />
                      </svg>
                    </span>
                  </button>

                  <div className=" dropdown-menu large-dropdown shadow-box rounded-md w-full border-0 ">
                    <div className=" py-2">
                      <Link
                        className="flex items-center px-4 py-2 justify-start bg-white border-0 w-full hover:bg-gray-100 text-sm text-neutral600"
                        to=""
                      >
                        <span className="mr-3">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.1586 10.87C12.0586 10.86 11.9386 10.86 11.8286 10.87C9.44859 10.79 7.55859 8.84 7.55859 6.44C7.55859 3.99 9.53859 2 11.9986 2C14.4486 2 16.4386 3.99 16.4386 6.44C16.4286 8.84 14.5386 10.79 12.1586 10.87Z"
                              stroke="#6F6E83"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.15875 14.56C4.73875 16.18 4.73875 18.82 7.15875 20.43C9.90875 22.27 14.4188 22.27 17.1688 20.43C19.5888 18.81 19.5888 16.17 17.1688 14.56C14.4288 12.73 9.91875 12.73 7.15875 14.56Z"
                              stroke="#6F6E83"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        My Profile
                      </Link>
                      <Link
                        className="flex items-center py-2 px-4 text-sm justify-start bg-white border-0 w-full hover:bg-gray-100 text-neutral600"
                        to=""
                      >
                        <span className="mr-3">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                              stroke="#6F6E83"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M16.1654 12.4999C16.0544 12.7513 16.0213 13.0301 16.0704 13.3004C16.1194 13.5707 16.2482 13.8202 16.4404 14.0166L16.4904 14.0666C16.6453 14.2214 16.7683 14.4052 16.8521 14.6075C16.936 14.8098 16.9792 15.0267 16.9792 15.2458C16.9792 15.4648 16.936 15.6817 16.8521 15.884C16.7683 16.0863 16.6453 16.2701 16.4904 16.4249C16.3356 16.5799 16.1518 16.7028 15.9494 16.7867C15.7471 16.8706 15.5302 16.9137 15.3112 16.9137C15.0922 16.9137 14.8753 16.8706 14.673 16.7867C14.4706 16.7028 14.2868 16.5799 14.132 16.4249L14.082 16.3749C13.8856 16.1828 13.6362 16.0539 13.3659 16.0049C13.0955 15.9559 12.8167 15.989 12.5654 16.0999C12.3189 16.2056 12.1087 16.381 11.9606 16.6045C11.8126 16.8281 11.7331 17.0901 11.732 17.3583V17.4999C11.732 17.9419 11.5564 18.3659 11.2439 18.6784C10.9313 18.991 10.5074 19.1666 10.0654 19.1666C9.62334 19.1666 9.19941 18.991 8.88685 18.6784C8.57429 18.3659 8.3987 17.9419 8.3987 17.4999V17.4249C8.39225 17.1491 8.30296 16.8816 8.14246 16.6572C7.98195 16.4328 7.75764 16.2618 7.4987 16.1666C7.24735 16.0557 6.96854 16.0226 6.69821 16.0716C6.42788 16.1206 6.17843 16.2495 5.98203 16.4416L5.93203 16.4916C5.77724 16.6465 5.59343 16.7695 5.3911 16.8533C5.18877 16.9372 4.97189 16.9804 4.75286 16.9804C4.53384 16.9804 4.31696 16.9372 4.11463 16.8533C3.9123 16.7695 3.72849 16.6465 3.5737 16.4916C3.41874 16.3368 3.29581 16.153 3.21193 15.9507C3.12806 15.7483 3.08489 15.5314 3.08489 15.3124C3.08489 15.0934 3.12806 14.8765 3.21193 14.6742C3.29581 14.4719 3.41874 14.288 3.5737 14.1332L3.6237 14.0833C3.81581 13.8869 3.94469 13.6374 3.9937 13.3671C4.04272 13.0967 4.00963 12.8179 3.8987 12.5666C3.79306 12.3201 3.61766 12.1099 3.39409 11.9618C3.17051 11.8138 2.90852 11.7343 2.64036 11.7333H2.4987C2.05667 11.7333 1.63275 11.5577 1.32019 11.2451C1.00763 10.9325 0.832031 10.5086 0.832031 10.0666C0.832031 9.62456 1.00763 9.20063 1.32019 8.88807C1.63275 8.57551 2.05667 8.39992 2.4987 8.39992H2.5737C2.84953 8.39347 3.11703 8.30418 3.34145 8.14368C3.56586 7.98317 3.73679 7.75886 3.83203 7.49992C3.94296 7.24857 3.97605 6.96976 3.92703 6.69943C3.87802 6.4291 3.74914 6.17965 3.55703 5.98325L3.50703 5.93325C3.35207 5.77846 3.22914 5.59465 3.14526 5.39232C3.06139 5.18999 3.01822 4.97311 3.01822 4.75408C3.01822 4.53506 3.06139 4.31818 3.14526 4.11585C3.22914 3.91352 3.35207 3.72971 3.50703 3.57492C3.66182 3.41996 3.84563 3.29703 4.04796 3.21315C4.25029 3.12928 4.46717 3.08611 4.6862 3.08611C4.90522 3.08611 5.1221 3.12928 5.32443 3.21315C5.52676 3.29703 5.71058 3.41996 5.86536 3.57492L5.91536 3.62492C6.11176 3.81703 6.36121 3.94591 6.63154 3.99492C6.90187 4.04394 7.18068 4.01085 7.43203 3.89992H7.4987C7.74517 3.79428 7.95538 3.61888 8.10344 3.39531C8.2515 3.17173 8.33096 2.90974 8.33203 2.64159V2.49992C8.33203 2.05789 8.50763 1.63397 8.82019 1.32141C9.13275 1.00885 9.55667 0.833252 9.9987 0.833252C10.4407 0.833252 10.8646 1.00885 11.1772 1.32141C11.4898 1.63397 11.6654 2.05789 11.6654 2.49992V2.57492C11.6664 2.84307 11.7459 3.10506 11.894 3.32864C12.042 3.55221 12.2522 3.72762 12.4987 3.83325C12.75 3.94418 13.0289 3.97727 13.2992 3.92826C13.5695 3.87924 13.819 3.75037 14.0154 3.55825L14.0654 3.50825C14.2202 3.35329 14.404 3.23036 14.6063 3.14649C14.8086 3.06261 15.0255 3.01944 15.2445 3.01944C15.4636 3.01944 15.6804 3.06261 15.8828 3.14649C16.0851 3.23036 16.2689 3.35329 16.4237 3.50825C16.5787 3.66304 16.7016 3.84685 16.7855 4.04918C16.8693 4.25151 16.9125 4.46839 16.9125 4.68742C16.9125 4.90644 16.8693 5.12332 16.7855 5.32565C16.7016 5.52798 16.5787 5.7118 16.4237 5.86658L16.3737 5.91658C16.1816 6.11298 16.0527 6.36243 16.0037 6.63276C15.9547 6.90309 15.9878 7.1819 16.0987 7.43325V7.49992C16.2043 7.74639 16.3797 7.9566 16.6033 8.10466C16.8269 8.25272 17.0889 8.33218 17.357 8.33325H17.4987C17.9407 8.33325 18.3646 8.50885 18.6772 8.82141C18.9898 9.13397 19.1654 9.55789 19.1654 9.99992C19.1654 10.4419 18.9898 10.8659 18.6772 11.1784C18.3646 11.491 17.9407 11.6666 17.4987 11.6666H17.4237C17.1555 11.6677 16.8936 11.7471 16.67 11.8952C16.4464 12.0432 16.271 12.2534 16.1654 12.4999V12.4999Z"
                              stroke="#6F6E83"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        Settings
                      </Link>
                      <button className="flex items-center py-2 px-4 text-sm justify-start bg-white border-0 w-full hover:bg-gray-100 text-neutral600">
                        <span className="mr-3">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.89844 7.55999C9.20844 3.95999 11.0584 2.48999 15.1084 2.48999H15.2384C19.7084 2.48999 21.4984 4.27999 21.4984 8.74999V15.27C21.4984 19.74 19.7084 21.53 15.2384 21.53H15.1084C11.0884 21.53 9.23844 20.08 8.90844 16.54"
                              stroke="#EF4444"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M15.0011 12H3.62109"
                              stroke="#EF4444"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
                              stroke="#EF4444"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        Sign Out
                      </button>
                    </div>
                  </div>
                </div>
                <div className=" px-1 md:pr-3 ">
                  <span className="relative">
                    <span className="w-2 h-2 rounded-full absolute left-2 leading text-xs bg-secondary500 top-0 "></span>

                    <svg
                      width="20"
                      height="23"
                      viewBox="0 0 20 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 17.3476C15.6392 17.3476 18.2481 16.6242 18.5 13.7205C18.5 10.8188 16.6812 11.0054 16.6812 7.44511C16.6812 4.66414 14.0452 1.5 10 1.5C5.95477 1.5 3.31885 4.66414 3.31885 7.44511C3.31885 11.0054 1.5 10.8188 1.5 13.7205C1.75295 16.6352 4.36177 17.3476 10 17.3476Z"
                        stroke="#667085"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.3889 20.3572C11.0247 21.8719 8.89672 21.8899 7.51953 20.3572"
                        stroke="#667085"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- End of Header --> */}

          <div className="main-box">
            <div className="h-full pb-24 px-4 md:px-12">
              <h1 className="text-3xl font-bold text-gray-800  ">
                Welcome, Rebecca
              </h1>
              <h2 className="text-md text-gray-400">
                Here&#x27;s what&#x27;s happening with your account today.
              </h2>
              <div className="flex my-6 items-stretch w-full space-y-4 md:space-x-4 md:space-y-0 flex-col md:flex-row">
                <div className="w-full md:w-7/12 flex-col  md:space-y-4">
                  <div className="shadow w-full bg-white    relative overflow-hidden px-6 py-6 rounded">
                    <div className="flex items-center justify-between pb-3 space-x-4">
                      <span className="text-neutral700">
                        Finish setting up your account information
                      </span>

                      <button>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 4L4 12"
                            stroke="#9998A9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4 4L12 12"
                            stroke="#9998A9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    <Link to="no-link" className="w-full h-full block ">
                      <div className="flex items-center justify-between flex-wrap px-4 py-6 space-x-4 border border-neutral100 rounded-lg">
                        <div className=" mt-6 md:mt-0 text-black flex flex-col gap-2  font-normal text-md">
                          Update business information
                          <span className="text-xs text-gray-400">
                            One more step to bring your business global
                          </span>
                        </div>
                        <div className="flex items-center mt-3 md:mt-0">
                          <span>
                            {/* <img src="images/Progress circle.png" /> */}
                          </span>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="shadow-lg w-full bg-white mt-3 md:mt-0  relative overflow-hidden">
                    <Link to="no-link" className="w-full h-full block">
                      <div className="flex items-center justify-between w-full">
                        {/* check this  */}
                        {/* <img src="images/Video player.png" class="w-full" /> */}
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="flex items-center w-full md:w-5/12 space-x-4 h-full">
                  <div className="w-full h-full">
                    <div className="shadow px-4 py-6 w-full bg-white   relative">
                      <div className="w-full border-b border-gray-200 flex items-center justify-between pb-2">
                        <h4 className="text-xl  text-gray-700   font-semibold ">
                          Recent Activities
                        </h4>

                        <Link to="nolink" className="text-sm text-secondary">
                          View all
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 my-4">
                <div className="w-full bg-white shadow px-4 py-6">
                  <div className="w-full relative">
                    <div className="w-full border-b border-gray-200 flex items-start md:items-center justify-between py-4 flex-wrap md:flex-row flex-col md:gap-0 gap-3">
                      <h4 className="text-xl text-gray-700 font-semibold flex items-start flex-col">
                        Revenue
                        <button className="flex items-center text-gray-400 text-sm border-gray-300 border mt-4 px-3 py-2 rounded">
                          <svg
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="mr-2 text-gray-400"
                            viewBox="0 0 1792 1792"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M192 1664h288v-288h-288v288zm352 0h320v-288h-320v288zm-352-352h288v-320h-288v320zm352 0h320v-320h-320v320zm-352-384h288v-288h-288v288zm736 736h320v-288h-320v288zm-384-736h320v-288h-320v288zm768 736h288v-288h-288v288zm-384-352h320v-320h-320v320zm-352-864v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm736 864h288v-320h-288v320zm-384-384h320v-288h-320v288zm384 0h288v-288h-288v288zm32-480v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm384-64v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"></path>
                          </svg>
                          Last month
                          <svg
                            width="14"
                            height="14"
                            className="ml-2 text-gray-400"
                            fill="currentColor"
                            viewBox="0 0 1792 1792"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"></path>
                          </svg>
                        </button>
                      </h4>

                      <div className="flex items-start flex-col gap-2">
                        <p href="" className="text-sm text-gray-400">
                          Available balance:{" "}
                          <span className="font-semibold text-xl text-gray-700">
                            $0.00
                          </span>
                        </p>
                        <Link
                          to="index.html"
                          className="h-12 py-2 px-2  bg-secondary hover:bg-secondary/80 text-white w-full transition ease-in duration-200 text-center text-sm font-semibold shadow-md   rounded flex items-center justify-center "
                        >
                          Withdraw
                        </Link>
                      </div>
                    </div>

                    <div className="py-7 mb-6 border-b border-neutral100">
                      <div
                        id="myfirstchart"
                        // check this below
                        // style="height: 250px; width: 100%;"
                      ></div>
                    </div>
                  </div>

                  <div className=" w-full    relative">
                    <h5 className="text-gray-400 mb-3 ">Assets</h5>

                    <div className=" ">
                      <div className="flex items-center py-4 mb-2 text-sm sm:space-x-12  justify-between border-b border-gray-200">
                        <div className="flex items-center justify-start gap-2">
                          <span>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M24 48.5C37.2548 48.5 48 37.7548 48 24.5C48 11.2452 37.2548 0.5 24 0.5C10.7452 0.5 0 11.2452 0 24.5C0 37.7548 10.7452 48.5 24 48.5Z"
                                fill="#45CD85"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27.466 27.6859H29.3733V26.1882C32.1865 25.85 33.9984 24.2074 33.9984 21.985C33.9984 18.893 31.5667 18.2166 29.2779 17.7818V13.6752C30.3746 13.7719 31.5667 14.11 32.6633 14.6415V12.2259C31.6143 11.8394 30.47 11.5978 29.3733 11.5495V10.1001H27.466V11.5495C24.5574 11.8877 22.8885 13.5303 22.8885 15.6077C22.8885 18.7481 25.2726 19.4727 27.5614 19.9076V24.0141C26.1786 23.8209 24.7004 23.2411 22.9839 22.3232V24.8838C24.462 25.6084 25.9878 26.0916 27.466 26.1882V27.6859ZM33.2355 30.0532C31.7574 34.2564 27.7998 37.3001 23.1269 37.3001C17.2143 37.3001 12.3984 32.4205 12.3984 26.4298C12.3984 21.6951 15.4024 17.6852 19.5508 16.1875V19.1346C16.8806 20.439 15.0686 23.2411 15.0686 26.4298C15.0686 30.9228 18.6925 34.5946 23.1269 34.5946C26.2739 34.5946 29.0395 32.7587 30.3269 30.0532H33.2355ZM29.2779 20.0525V24.0141C30.7561 23.8209 31.662 23.0479 31.662 21.985C31.662 20.8255 30.613 20.3907 29.2779 20.0525ZM25.2249 15.6077C25.2249 16.8156 26.2263 17.2987 27.5614 17.5886V13.6752C26.0832 13.8202 25.2249 14.4965 25.2249 15.6077Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                          <div className="flex items-start gap-1 flex-col">
                            <p className="text-xl">cUSD</p>
                            <p>Celo US Dollar</p>
                          </div>
                        </div>
                        <div className="flex items-start text-xs flex-col">
                          <h4 className="text-xl">$ 0.00</h4>
                          <span className="flex items-center">cUSD 0.00</span>
                        </div>
                      </div>

                      <div className="flex items-center py-4 mb-2 text-sm sm:space-x-12  justify-between border-b border-gray-200">
                        <div className="flex items-center justify-start gap-2">
                          <span>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_1248_13586)">
                                <path
                                  d="M24 48.5C37.2548 48.5 48 37.7548 48 24.5C48 11.2452 37.2548 0.5 24 0.5C10.7452 0.5 0 11.2452 0 24.5C0 37.7548 10.7452 48.5 24 48.5Z"
                                  fill="#45CD85"
                                />
                                <path
                                  d="M21.3586 37.94C26.0626 37.94 30.0466 34.916 31.5346 30.74H28.6066C27.3106 33.428 24.5266 35.252 21.3586 35.252C16.8946 35.252 13.2466 31.604 13.2466 27.14C13.2466 23.972 15.0706 21.188 17.7586 19.892V16.964C13.5826 18.452 10.5586 22.436 10.5586 27.14C10.5586 33.092 15.4066 37.94 21.3586 37.94ZM30.3826 27.62C31.9666 27.62 33.4546 27.188 34.7026 26.42V23.924C33.5026 24.836 32.0626 25.412 30.4306 25.412C28.1266 25.412 26.3026 24.308 25.4386 22.484H31.8226L32.3986 20.564H24.8626C24.8146 20.276 24.8146 20.036 24.8146 19.748C24.8146 19.46 24.8146 19.172 24.8626 18.884H32.9266L33.5026 16.964H25.3906C26.2546 15.092 28.0306 13.988 30.4306 13.988C31.7266 13.988 32.9746 14.324 34.1266 14.948L34.7986 12.788C33.5026 12.116 31.9666 11.78 30.4306 11.78C26.8306 11.78 23.9986 13.844 22.9426 16.916H20.8306L20.2546 18.74H22.5586C22.5106 19.076 22.5106 19.412 22.5106 19.748C22.5106 20.084 22.5106 20.372 22.5586 20.708H20.8306L20.2546 22.532H22.9906C23.9986 25.604 26.7826 27.62 30.3826 27.62Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1248_13586">
                                  <rect
                                    width="48"
                                    height="48"
                                    fill="white"
                                    transform="translate(0 0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <div className="flex items-start gap-1 flex-col">
                            <p className="text-xl">cEUR</p>
                            <p>Celo Euro</p>
                          </div>
                        </div>
                        <div className="flex items-start text-xs flex-col">
                          <h4 className="text-xl">€ 0.00</h4>
                          <span className="flex items-center">cEUR 0.00</span>
                        </div>
                      </div>

                      <div className="flex items-center py-4 mb-2 text-sm sm:space-x-12  justify-between border-b border-gray-200">
                        <div className="flex items-center justify-start gap-2">
                          <span>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_1248_13586)">
                                <path
                                  d="M24 48.5C37.2548 48.5 48 37.7548 48 24.5C48 11.2452 37.2548 0.5 24 0.5C10.7452 0.5 0 11.2452 0 24.5C0 37.7548 10.7452 48.5 24 48.5Z"
                                  fill="#45CD85"
                                />
                                <path
                                  d="M21.3586 37.94C26.0626 37.94 30.0466 34.916 31.5346 30.74H28.6066C27.3106 33.428 24.5266 35.252 21.3586 35.252C16.8946 35.252 13.2466 31.604 13.2466 27.14C13.2466 23.972 15.0706 21.188 17.7586 19.892V16.964C13.5826 18.452 10.5586 22.436 10.5586 27.14C10.5586 33.092 15.4066 37.94 21.3586 37.94ZM30.3826 27.62C31.9666 27.62 33.4546 27.188 34.7026 26.42V23.924C33.5026 24.836 32.0626 25.412 30.4306 25.412C28.1266 25.412 26.3026 24.308 25.4386 22.484H31.8226L32.3986 20.564H24.8626C24.8146 20.276 24.8146 20.036 24.8146 19.748C24.8146 19.46 24.8146 19.172 24.8626 18.884H32.9266L33.5026 16.964H25.3906C26.2546 15.092 28.0306 13.988 30.4306 13.988C31.7266 13.988 32.9746 14.324 34.1266 14.948L34.7986 12.788C33.5026 12.116 31.9666 11.78 30.4306 11.78C26.8306 11.78 23.9986 13.844 22.9426 16.916H20.8306L20.2546 18.74H22.5586C22.5106 19.076 22.5106 19.412 22.5106 19.748C22.5106 20.084 22.5106 20.372 22.5586 20.708H20.8306L20.2546 22.532H22.9906C23.9986 25.604 26.7826 27.62 30.3826 27.62Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1248_13586">
                                  <rect
                                    width="48"
                                    height="48"
                                    fill="white"
                                    transform="translate(0 0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <div className="flex items-start gap-1 flex-col">
                            <p className="text-xl">cReal</p>
                            <p>Celo Real</p>
                          </div>
                        </div>
                        <div className="flex items-start text-xs flex-col">
                          <h4 className="text-xl">R$ 0.00</h4>
                          <span className="flex items-center">cReal 0.00</span>
                        </div>
                      </div>

                      <div className="flex items-center py-4 mb-2 text-sm sm:space-x-12  justify-between ">
                        <div className="flex items-center justify-start gap-2">
                          <span>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="24" cy="24.5" r="24" fill="#E7EFF3" />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10 27.4474C10 33.5514 14.9486 38.5 21.0526 38.5C27.1566 38.5 32.1053 33.5514 32.1053 27.4474C32.1053 21.3434 27.1566 16.3948 21.0526 16.3948C14.9486 16.3948 10 21.3434 10 27.4474ZM29.1579 27.4474C29.1579 31.9245 25.5297 35.5527 21.0526 35.5527C16.5756 35.5527 12.9474 31.9245 12.9474 27.4474C12.9474 22.9704 16.5756 19.3421 21.0526 19.3421C25.5297 19.3421 29.1579 22.9704 29.1579 27.4474Z"
                                fill="#FBCC5C"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M15.8945 21.5526C15.8945 27.6566 20.8432 32.6053 26.9472 32.6053C33.0512 32.6053 37.9998 27.6566 37.9998 21.5526C37.9998 15.4486 33.0512 10.5 26.9472 10.5C20.8432 10.5 15.8945 15.4486 15.8945 21.5526ZM35.0524 21.5526C35.0524 26.0297 31.4242 29.6579 26.9472 29.6579C22.4701 29.6579 18.8419 26.0297 18.8419 21.5526C18.8419 17.0756 22.4701 13.4474 26.9472 13.4474C31.4242 13.4474 35.0524 17.0756 35.0524 21.5526Z"
                                fill="#35D07F"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M15.8945 21.1872C16.8259 20.4209 17.9135 19.8727 19.0806 19.5809C19.3724 18.4108 19.9206 17.3232 20.687 16.3948C19.3371 16.439 18.0019 16.7308 16.7552 17.2554C16.2276 18.5021 15.9358 19.8344 15.8945 21.1872ZM28.919 29.4192C28.6272 30.5893 28.079 31.6769 27.3126 32.6053C28.6655 32.564 29.9977 32.2722 31.2444 31.7476C31.772 30.4979 32.0638 29.1657 32.1051 27.8129C31.1737 28.5792 30.0861 29.1274 28.919 29.4192Z"
                                fill="#5EA33B"
                              />
                            </svg>
                          </span>
                          <div className="flex items-start gap-1 flex-col">
                            <p className="text-xl">Celo</p>
                            <p>Celo Coin</p>
                          </div>
                        </div>
                        <div className="flex items-start text-xs flex-col">
                          <h4 className="text-xl">$ 0.00</h4>
                          <span className="flex items-center">Celo 0.00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
